import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { MapURLInformation } from "adoms-common-lib";
import React from "react";
import { APIConnector } from "../../connector/APIConnector";

type DeleteMapURLDialogProps = {
    open: boolean;
    mapURLInfo?: MapURLInformation;
    onClose: () => void;
    onDelete: () => void;
};

export const DeleteMapURLDialog: React.FC<DeleteMapURLDialogProps> = (props) => {
    const { open, mapURLInfo, onClose, onDelete } = props;
    //エラーメッセージ格納用State
    const [errorMessage, setErrorMessage] = React.useState<string | undefined>(undefined);
    
    if (!mapURLInfo) {
        return null;
    }

    const handleClose = () => {
        setErrorMessage(undefined); // エラーメッセージをリセット
        onClose();
    };

    const handleDelete = async () => {
        const apiConnector = new APIConnector();
        await apiConnector.deleteMapURLInformation(mapURLInfo.urlId)
            .then(() => {
                onDelete();
            })
            .catch((error: any) => {
                console.error("Error deleting map URL:", error);
                setErrorMessage("URLの削除に失敗しました。しばらく経ってからもう一度お試しください。");
            });
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="delete-dialog-title"
            aria-describedby="delete-dialog-description"
        >
            <DialogTitle id="delete-dialog-title">
                {"URLの削除"}
            </DialogTitle>
            <DialogContent>
                {errorMessage && <Alert severity="error" sx={{ marginBottom: 2 }}>
                    {errorMessage}
                </Alert>}
                <DialogContentText id="delete-dialog-description">
                    ID: {mapURLInfo.urlId} を削除します。<br />よろしいですか？
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>キャンセル</Button>
                <Button onClick={handleDelete} color="primary" autoFocus>
                    削除
                </Button>
            </DialogActions>
        </Dialog>
    );
};
